// extracted by mini-css-extract-plugin
export default {"noPointerEvents":"blocks_safe-anchor_noPointerEvents"};